export enum AnalysisSupplierStatus {
    NEW = 'NEW',
    OUTSTANDING = 'OUTSTANDING',
    CONFIRMED = 'CONFIRMED'
}
